export const proposalsSliceName = "proposals"
